let clocks = document.querySelectorAll('.js-clock');
if (clocks) {
    clocks.forEach(el => {
        let buttons = el.querySelectorAll('.js-clock-timezone');
        let hrs = el.querySelector(".js-clock-hours");
        let min = el.querySelector(".js-clock-minutes");
        let sec = el.querySelector(".js-clock-seconds");
        let ampm = el.querySelector(".js-clock-ampm");

        let currentTimeZone = 'Europe/London';
        if (buttons) {
            // Set first as default selected.
            currentTimeZone = buttons[0].getAttribute('data-timezone');
            buttons[0].classList.add('button--ghost');
        }
        function updateTime() {
            let now = new Date();
            let options = {
                timeZone: currentTimeZone,
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true
            };
            let formatter = new Intl.DateTimeFormat("en-US", options);
            let formattedTime = formatter.formatToParts(now);
            let hours = formattedTime.find(part => part.type === "hour").value.padStart(2, "0");
            let minutes = formattedTime.find(part => part.type === "minute").value.padStart(2, "0");
            let seconds = formattedTime.find(part => part.type === "second").value.padStart(2, "0");

            hrs.innerHTML = `
                                                          <span>${hours[0]}</span>
                                                          <span>${hours[1]}</span>`;
            min.innerHTML = `
                                                          <span>${minutes[0]}</span>
                                                          <span>${minutes[1]}</span>`;
            sec.innerHTML = `
                                                          <span>${seconds[0]}</span>
                                                          <span>${seconds[1]}</span>`;
            ampm.innerHTML = formattedTime.find(part => part.type === "dayPeriod").value.toUpperCase();
        }
        if (buttons) {
            buttons.forEach((item) => {
                item.addEventListener('click', () => {
                    currentTimeZone = item.getAttribute('data-timezone');
                    buttons.forEach((item) => {
                        item.classList.remove('button--ghost');
                    });
                    item.classList.add('button--ghost');
                    updateTime();
                });
            });
        }
        updateTime();
        setInterval(updateTime, 1000);
    });
}